import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Management {
  name: string
  code: string
  directionId: string
}

export async function getManagements(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['directions.company_id=:companyId']
  if (search) {
    where.push(
      `CONCAT(managements.name,managements.code,directions.name,directions.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN managements.code ~ '^[0-9]+$' THEN CAST(managements.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, managements.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN managements.code ~ '^[0-9]+$' THEN CAST(managements.code AS NUMERIC) ELSE NULL END), managements.code"
      ])
  const join = [
    'INNER JOIN directions ON managements.direction_id = directions.id',
    'INNER JOIN companies ON companies.id=directions.company_id'
  ]
  // result
  const response: any = await getData({
    tables: ['pg_managements'],
    fields: [
      'managements.id',
      'managements.code',
      'managements.name',
      "CONCAT(directions.code,' - ',directions.name) as directions",
      'managements.is_inactive',
      'managements.updated_at'
    ],
    join,
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getManagement(id: string): Promise<Management> {
  const data = await getData<any>({
    tables: ['pg_managements'],
    fields: [
      'id',
      'name',
      'code',
      'direction_id as directionId',
      'is_inactive',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createManagement(data: Management): Promise<boolean> {
  const response: any = await http.post('payroll/managements', {
    name: data.name,
    code: data.code,
    directionId: data.directionId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateManagement(
  data: Management,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/managements/' + id, {
    name: data.name,
    code: data.code,
    directionId: data.directionId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateManagement(
  id: string,
  state: boolean
): Promise<boolean> {
  const response: any = await http.put(`/payroll/managements/${id}/enable`, {
    enable: state
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteManagement(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/managements/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
